import { Component, EventEmitter, OnInit, Output, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { SettingsmanagerService } from "src/app/services/settingsmanager.service";

@Component({
  selector: "app-switch-language-btn",
  templateUrl: "./switch-language-btn.component.html",
  styleUrls: ["./switch-language-btn.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchLanguageBtnComponent implements OnInit {
  @Output() languageChanged = new EventEmitter<string>();

  public initialLocaleValue: string;
  public localeOptions: { name: string }[];

  constructor(private settingsManager: SettingsmanagerService) {}

  ngOnInit(): void {
    this.localeOptions = this.settingsManager.getLocaleOptions();
    this.initialLocaleValue = this.settingsManager.getLanguageSetting();
  }

  public selectChangeEvent(event: any) {
    this.languageChanged.emit(event.detail.value);
  }
}
